import { animated, useSpring } from '@react-spring/web';

import { LoadingSpinner, ScrollArea } from '@app/shared/ui/atoms/Common';
import { Description } from '@app/shared/ui/molecules/DailyEnergyDescription';
import { TopBar, MoonPhasesList } from '@app/shared/ui/organisms/DailyEnergyDescription';
import { usePreloadImages } from '@app/shared/hooks/usePreloadImages';
import { FIRST_DESCRIPTION_SPRING_CONFIG } from '@app/shared/constants/dailyEnergyDescription';
import { DAILY_ENERGY_DESCRIPTION_PRELOAD_IMAGES } from '@app/assets';

export default function DailyEnergyDescriptionPage() {
  const firstDescriptionSprings = useSpring({ ...FIRST_DESCRIPTION_SPRING_CONFIG });
  const isImagesLoading = usePreloadImages(DAILY_ENERGY_DESCRIPTION_PRELOAD_IMAGES);

  if (isImagesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ScrollArea className="gap-4">
      <TopBar />

      <animated.div style={firstDescriptionSprings}>
        <Description translationKey="daily_energy_description.first_description" />
      </animated.div>

      <MoonPhasesList />

      <Description translationKey="daily_energy_description.second_description" />
    </ScrollArea>
  );
}
